import SubcontractorAdjustmentPriceCreate from "./SubcontractorAdjustmentPriceCreate";
import SubcontractorAdjustmentPriceEdit from "./SubcontractorAdjustmentPriceEdit";
import SubcontractorAdjustmentPriceList from "./SubcontractorAdjustmentPriceList";

export default {
  name: "subcontractorAdjustmentPrices",
  create: SubcontractorAdjustmentPriceCreate,
  edit: SubcontractorAdjustmentPriceEdit,
  list: SubcontractorAdjustmentPriceList,
};
